export default "__VITE_ASSET__BNnkvpMy__"